import { Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'skipper',
    imports: [TranslocoDirective],
    templateUrl: './skipper.component.html'
})
export class SkipperComponent {
    scrollToMainContent() {
        const el = document.getElementById('maincontent');
        el?.scrollIntoView({ behavior: 'smooth' });
        (document.activeElement as HTMLElement)?.blur();
    }
}
